import { useCallback, useMemo, useState } from 'react';
import { OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL, isEmpty, EMPTY, pinEngagement } from 'crm-events-data';
import ReplacePinnedEngagementModal from '../crm_ui/timeline/components/pinnedEngagements/ReplacePinnedEngagementModal';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { triggerWootricsSurvey } from 'crm-events-components/internal/engagements/pinned/triggerWootricsSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
export const useReplacePinnedEngagementModalActionHandler = ({
  objectType,
  subjectId
}) => {
  const [engagementId, setEngagementId] = useState(EMPTY);
  const [engagementType, setEngagementType] = useState(EMPTY);
  const [engagementTrackingType, setEngagementTrackingType] = useState(EMPTY);
  const [pinnedEngagementType, setPinnedEngagementType] = useState(EMPTY);
  const [pinnedEngagementTrackingType, setPinnedEngagementTrackingType] = useState(EMPTY);
  const handleTrackPin = useCallback(({
    action,
    trackingType
  }) => {
    if (isEmpty(trackingType)) {
      return;
    }
    const updatedTrackingType = trackingType === 'incoming_email' ? 'email' : trackingType;
    CrmLogger.log('timelineUsage', {
      action,
      activity: updatedTrackingType
    });
  }, []);
  const handleReplacePinnedEngagement = useCallback(() => {
    if (pinnedEngagementTrackingType) {
      handleTrackPin({
        action: 'unpin event',
        trackingType: pinnedEngagementTrackingType
      });
    }
    if (engagementTrackingType) {
      handleTrackPin({
        action: 'pin event',
        trackingType: engagementTrackingType
      });
    }
    triggerWootricsSurvey();
    return pinEngagement(objectType, subjectId, engagementId);
  }, [engagementId, engagementTrackingType, handleTrackPin, objectType, pinnedEngagementTrackingType, subjectId]);
  const handleCloseModal = useCallback(() => {
    setEngagementId(EMPTY);
    setEngagementType(EMPTY);
    setEngagementTrackingType(EMPTY);
    setPinnedEngagementType(EMPTY);
    setPinnedEngagementTrackingType(EMPTY);
  }, []);
  const handleReplacePinnedEngagementModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL) {
      setEngagementId(data.engagementId);
      setEngagementType(data.engagementType);
      setEngagementTrackingType(data.engagementTrackingType);
      setPinnedEngagementType(data.pinnedEngagementType);
      setPinnedEngagementTrackingType(data.pinnedEngagementTrackingType);
    }
  }, []);
  const renderedReplacePinnedEngagementModal = useMemo(() => {
    if (!engagementType) {
      return null;
    }
    return /*#__PURE__*/_jsx(ReplacePinnedEngagementModal, {
      engagementType: engagementType
      // When an empty pinned engagement type is passed, the user does not have view permissions for the currently pinned engagement
      ,
      hasViewPermissions: !isEmpty(pinnedEngagementType),
      onCloseModal: handleCloseModal,
      pinnedEngagementType: pinnedEngagementType,
      replacePinnedEngagement: handleReplacePinnedEngagement
    });
  }, [engagementType, pinnedEngagementType, handleCloseModal, handleReplacePinnedEngagement]);
  return {
    handleReplacePinnedEngagementModalAction,
    replacePinnedEngagementModal: renderedReplacePinnedEngagementModal
  };
};